export default __webpack_public_path__ + "static/media/mageia.ed13d1ca.svg";